export type Group = '客服投入' | '工作成果' | '服务水平' | '参考指标';

export type SubGroup =
  | '接待'
  | '取消订单'
  | '仅退款'
  | '退货退款'
  | '评价'
  | '下单'
  | '付款'
  | '知识自学习';

export const groupList: Group[] = ['客服投入', '工作成果', '服务水平', '参考指标'];

export const groupSubListMap: Partial<Record<Group, SubGroup[]>> = {
  客服投入: ['接待', '取消订单', '仅退款', '退货退款', '评价', '知识自学习'],
  工作成果: ['下单', '付款', '取消订单', '仅退款', '退货退款', '评价', '知识自学习'],
  服务水平: ['接待', '下单', '付款', '取消订单', '仅退款', '退货退款', '评价', '知识自学习'],
  参考指标: ['接待', '评价'],
};
